import { PropsWithChildren, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Tooltip from '~/components/CommonTooltip';
import useResponsive from '~/hooks/useResponsive';
import { isSafari } from '~/utils/browser/isSafari';

const OpenTerminalSafariTooltip = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation('hosting', { keyPrefix: 'hostingNova' });
  const { isMobile } = useResponsive();
  const showSafariMessage = useMemo(() => isSafari(), []);
  const safariMessage = t('serverActionButtons.safariClipboardTooltip');

  if (!showSafariMessage) {
    return children;
  }

  if (isMobile()) {
    return (
      <Stack spacing={1}>
        {children}
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ textAlign: 'center' }}
          data-testid="safari-clipboard-message"
        >
          {safariMessage}
        </Typography>
      </Stack>
    );
  }

  return (
    <Tooltip title={safariMessage} arrow placement="top">
      <Box component="span" sx={{ display: 'block', width: '100%' }}>
        {children}
      </Box>
    </Tooltip>
  );
};

export default OpenTerminalSafariTooltip;
